<template>
    <v-container grid-list-md>
        <v-layout row wrap>

          <v-flex xs12>
              <h1>Campaign Type</h1>
          </v-flex>
          <v-flex xs12>
              <span>What you would like to achieve with your advertising campaign?
              </span>
          </v-flex>

            <v-flex xs12>
              <campaign-element-nonprofit
                      v-for="(campaign, index) in campaignTypes"
                      :key="index"
                      :campaign="campaign"
                      :selectedCampaign="selectedCampaign"
                      @selectCampaign="selectCampaign"
              ></campaign-element-nonprofit>
            </v-flex>
        </v-layout>
        <v-divider class="mt-3"></v-divider>
        <v-layout row align-content-end>
            <v-spacer></v-spacer><v-btn color="primary">Next</v-btn>
        </v-layout>
    </v-container>
</template>

<script>
  import CampaignElementNonprofit from './CampaignElementNonprofit.vue'
  export default {
    name: 'non-profit-campaign-type',
    components:
      {
        CampaignElementNonprofit
      },
    data () {
      return {
        campaignTypes: [
              {
                icon: 'email',
                title: 'Grow email list',
                value: 'grow_email_list',
                selectable: true,
                margin: 0
              },
              {
                icon: 'thumb_up',
                title: 'Add FB page followers',
                value: 'grow_fb_followers',
                selectable: true,
                margin: 0
              },

              {
                icon: 'credit_card',
                title: 'Fundraise',
                value: 'fundraise',
                selectable: true,
                margin: 0
              },
          {
            icon: 'touch_app',
            title: 'Promote online action',
            value: 'online_action',
            selectable: true,
            margin: 0
          },
        {
          icon: 'event',
          title: 'Promote an event',
          value: 'event',
          selectable: true,
          margin: 0
        }
      ],
        next: true,
        selectedCampaign: 'grow_email_list'
      }
    },
    methods: {
      selectCampaign (campaign) {
        this.selectedCampaign = campaign
      }
    }
  }
</script>

<style>
</style>
